import {
	ChangeDetectorRef,
	Component,
	ElementRef,
	inject,
	OnDestroy,
	OnInit,
} from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import {
	IIncident,
	IIncidentPayload,
} from '@app/pages/cmms/interfaces/incidents.interface';
import { iconEnum } from '@app/configs/model/IconEnum';
import { Store } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';
import { AuRightSidebarService } from '@core/services/au-right-sidebar.service';
import {
	setIncidentForEditing,
	startDeletingIncident,
	startEditIncident,
} from '@app/pages/cmms/components/incident/state/incidents.actions';
import { editingIncident } from '@app/pages/cmms/components/incident/state/incidents.selectors';
import { AuDialogService } from '@core/services/au-dialog.service';
import { mergeMap, takeUntil } from 'rxjs/operators';
import { CmmsPages, ICmmsState } from '@app/pages/cmms/state/cmms.reducer';
import { ICmmsAssignee } from '@app/pages/cmms/interfaces/assignee.interface';
import { RightSidebarNavigationService } from '@layout/au-right-sidebar/right-sidebar-navigation.service';
import { AuErrorAdapter, AuUtilsFunctions } from '@app/shared';
import { IconSnackBarService } from '@core/services/icon-snack-bar.service';
import { TableType } from '@app/pages/cmms/types';
import { ACTIVE_PAGE_CONFIG } from '@app/pages/cmms/configs/active-page.config';
import { SetRightSidebarComponentContext } from '@layout/state/layout.actions';
import { RequestsService } from '@app/pages/cmms/services/requests.service';
import { IRequest } from '@app/pages/cmms/interfaces/request.interfaces';
import {
	attachedEntityTableConfig,
	sidebarHeaders,
} from '@app/pages/cmms/configs/cmms-table-configs';
import { ICMMSColumn } from '@shared/ui-components/au-table-layout/utils/interfaces';
import { IncidentsService } from '@app/pages/cmms/services/incidents.service';
import { CmmsCommentsService } from '@app/pages/cmms/services/cmms-comments.service';
import { ICMMSLocation } from '@app/pages/cmms/interfaces/cmms-global.interfaces';
import { ICmmsAsset } from '@app/pages/cmms/interfaces/assets.interfaces';
import { CMMS_STATUSES } from '@app/pages/cmms/configs/statuses-by-entity';
import { FilesService } from '@app/pages/cmms/services/files.service';
import { RightSidebarAliasesEnum } from '@layout/au-right-sidebar/au-right-sidebar-component-aliases';
import { CommonModule, DatePipe } from '@angular/common';
import { fileTypesConfig } from '@app/pages/cmms/configs/file-filter.config';
import { CmmsSharedService } from '@app/pages/cmms/services/cmms-shared.service';
import { CmmsEntityNameComponent } from '../../shared-form-group-controls/cmms-entity-name/cmms-entity-name.component';
import { MatRippleModule } from '@angular/material/core';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { AuAvatarWithNameModule } from '@app/shared/ui-components';
import { AuPipesModule } from '@app/shared/pipes/au-pipes.module';
import { CmmsEntityStatusComponent } from '../../shared-form-group-controls/cmms-entity-status/cmms-entity-status.component';
import { CmmsLocationsSectionComponent } from '../../shared-form-group-controls/cmms-locations-section/cmms-locations-section.component';
import { CmmsPriorityLevelComponent } from '../../shared-form-group-controls/cmms-priorirty-level/cmms-priority-level.component';
import { CmmsEntityCategoryComponent } from '../../shared-form-group-controls/cmms-entity-category/cmms-entity-category.component';
import { CmmsAssigeeAndApproverComponent } from '../../shared-form-group-controls/cmms-assignees-and-approver/cmms-assigee-and-approver.component';
import { CmmsDatePickerComponent } from '../../shared-form-group-controls/cmms-date-picker/cmms-date-picker.component';
import { CmmsLabelsSectionComponent } from '../../shared-form-group-controls/cmms-labels-section/cmms-labels-section.component';
import { CmmsDescriptionComponent } from '../../shared-form-group-controls/cmms-description/cmms-description.component';
import { MaintenanceSectionComponent } from '../../maintenance-section/maintenance-section.component';
import { AuMaintenanceSelectorComponent } from '../../au-maintenance-selector/au-maintenance-selector.component';
import { AuCmmsCostComponent } from '../../au-cmms-cost/au-cmms-cost.component';
import { EntitySectionComponent } from '../../entity-section/entity-section.component';
import { AssetsSectionComponent } from '../../assets-section/assets-section.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { IAttachFiles } from '@app/shared/ui-components/au-file-loader/au-file-loader.interfaces';
import { OpenDtFromWorkspaceComponent } from '@app/pages/cmms/components/shared-form-group-controls/cmms-open-dt-from-workspace/open-dt-from-workspace.component';
import { AuCommentsComponent } from '@app/shared/ui-components/au-comments/au-comments.component';
import { EmailService } from '@app/pages/settings/email-service/email-service.service';
import { ImageSectionComponent } from '../../files/image-section/image-section.component';
import { CommentInputComponent } from '@app/shared/ui-components/au-comments/comment-input/comment-input.component';
import { NgxTolgeeModule, TranslateService } from '@tolgee/ngx';
import { IWorkOrder } from '@app/domain/cmms-types/workorder-types';
import { AuFileLoaderComponent } from '@app/shared/ui-components/au-file-loader/au-file-loader.component';
import {
	AttachNewQuickEntityComponent,
	ActionType,
} from '@app/shared/entity-workspace-components/quick-entity/attach-new-quick-entity/attach-new-quick-entity.component';

@Component({
	selector: 'edit-incident',
	templateUrl: './edit-incident.component.html',
	styleUrls: ['./edit-incident.component.scss'],
	imports: [
		CommonModule,
		CmmsEntityNameComponent,
		MatRippleModule,
		MatMenuModule,
		MatIconModule,
		AuAvatarWithNameModule,
		AuPipesModule,
		CmmsEntityStatusComponent,
		CmmsLocationsSectionComponent,
		CmmsPriorityLevelComponent,
		CmmsEntityCategoryComponent,
		CmmsAssigeeAndApproverComponent,
		CmmsDatePickerComponent,
		CmmsLabelsSectionComponent,
		CmmsDescriptionComponent,
		MaintenanceSectionComponent,
		AuMaintenanceSelectorComponent,
		AuCmmsCostComponent,
		EntitySectionComponent,
		AssetsSectionComponent,
		AuCommentsComponent,
		MatProgressSpinnerModule,
		OpenDtFromWorkspaceComponent,
		ImageSectionComponent,
		CommentInputComponent,
		NgxTolgeeModule,
		AuFileLoaderComponent,
		AttachNewQuickEntityComponent,
	],
})
export class EditIncidentComponent implements OnInit, OnDestroy {
	private readonly fb = inject(FormBuilder);
	private readonly sidebarService = inject(AuRightSidebarService);
	private readonly store$ = inject(Store<ICmmsState>);
	private readonly dialogService = inject(AuDialogService);
	private readonly sidebarNavigation = inject(RightSidebarNavigationService);
	private readonly requestService = inject(RequestsService);
	private readonly notify = inject(IconSnackBarService);
	private readonly commentService = inject(CmmsCommentsService);
	private readonly incidentService = inject(IncidentsService);
	private readonly cd = inject(ChangeDetectorRef);
	private readonly filesService = inject(FilesService);
	private readonly datePipe = inject(DatePipe);
	private readonly cmmsSharedService = inject(CmmsSharedService);
	private readonly emailService = inject(EmailService);
	private readonly el = inject(ElementRef);
	private readonly translateService = inject(TranslateService);

	incidentForm: FormGroup = this.fb.group({});
	incident: IIncident;
	attachedRequest: IRequest[] = [];
	attachedWO: IWorkOrder[] = [];
	attachedAssets: ICmmsAsset[] = [];
	attachedFiles: IAttachFiles[] = [];

	readonly iconEnum = iconEnum;
	readonly cmmsPages = CmmsPages;
	readonly tableType = TableType;
	readonly EntityType = ActionType;

	readonly tableConfig: ICMMSColumn[] = attachedEntityTableConfig;
	readonly incidentStatuses = CMMS_STATUSES.INCIDENTS;

	isFullscreen$: Observable<boolean>;
	locationAncestry: Partial<ICMMSLocation>[] = [];

	private destroy$: Subject<void> = new Subject<void>();

	ngOnInit(): void {
		this.isFullscreen$ = this.sidebarService.sidebarFullscreen$;
		this.getIncidentForEdit();
		this.trackSidebarCloseAction();
	}

	trackSidebarCloseAction(): void {
		this.sidebarService.sidebarIsClosing$.pipe(takeUntil(this.destroy$)).subscribe(() => {
			this.sidebarService.closeAndClearPortal();
		});
	}

	reloadPage() {
		this.editIncident({ name: this.incident.name }, true);
	}

	getIncidentForEdit() {
		this.store$
			.select(editingIncident)
			.pipe(
				takeUntil(this.destroy$),
				mergeMap(incident => this.incidentService.getIncidentByPk(incident.pk))
			)
			.subscribe(incident => {
				this.incident = { ...incident };

				if (incident.requestIncident) {
					this.attachedRequest = [
						...this.requestService.getRequestsData(incident.requestIncident).requests,
					];
				}
				if (incident.workOrders) {
					this.attachedWO = [...incident.workOrders];
				}

				if (incident.files) {
					this.attachedFiles = this.incident.files.filter(
						file => file.importConfirmed || !file.importId
					);
				}

				this.attachedAssets = this.incident.assets || [];

				this.cd.markForCheck();
			});
	}

	assigneeUpdate(assignee: Partial<ICmmsAssignee>) {
		this.editIncident({
			assignee: assignee.psId,
			assigneeType: assignee.contentType,
		});
	}

	approverUpdate(approver: Partial<ICmmsAssignee>) {
		this.editIncident({
			approvedBy: approver.psId,
			approverType: approver.contentType,
		});
	}

	locationsChanged($event: ICMMSLocation[]) {
		this.editIncident({
			locations: $event,
		});
	}

	occurredAtChanged($event: Date) {
		this.editIncident({
			occurredAt: this.datePipe.transform($event, 'yyyy-MM-ddT00:00:00'),
		});
	}

	filesUpdates(fileIds: string[]) {
		this.store$.dispatch(
			startEditIncident({
				incident: {
					pk: this.incident.pk,
					files: fileIds,
				},
			})
		);
		this.filesService.getUpdatedFiles();
	}

	filesDeleted({ ids, onSuccess }: { ids: string[]; onSuccess: () => void }) {
		const incidentCopy = AuUtilsFunctions.deepCopyObject(this.incident);

		incidentCopy.files = this.incident.files.filter(file => !ids.includes(file.pk));

		this.filesService
			.unlinkAttachedElements({
				pk: ids[0],
				incidents: this.incident.pk,
			})
			.subscribe(() => {
				onSuccess();
				this.store$.dispatch(setIncidentForEditing({ incidentEdit: incidentCopy }));
				this.notify.success(
					`${this.translateService.instant('incident')} ${this.translateService.instant('has_been_updated_successfully')}`
				);
			});
	}

	editIncident(incident: Partial<IIncidentPayload>, overrideCheck = false) {
		if (this.checkIfIncidentChanged(incident) || overrideCheck) {
			this.store$.dispatch(
				startEditIncident({
					incident: {
						pk: this.incident.pk,
						name: this.incident.name,
						description: this.incident.description,
						...incident,
					},
				})
			);
		}
	}

	checkIfIncidentChanged(newIncident: Partial<IIncidentPayload>) {
		let hasChanges = false;
		Object.keys(newIncident).map(key => {
			if (newIncident[key] !== this.incident[key]) {
				hasChanges = true;
			}
		});

		return hasChanges;
	}

	incidentDeleteBtnHandler(): void {
		const dialog = this.dialogService.openAlertDialog({
			title: this.translateService.instant('dialog_delete_incident_title'),
			description: `<p class="au-cmms-alert-text">${this.translateService.instant('dialog_delete_data_loss_warning')}</p><p class="au-cmms-alert-text">${this.translateService.instant('dialog_delete_incident_description')}</p>`,
			actionBtnText: this.translateService.instant('delete'),
		});

		this.dialogService.closedByEnter(dialog).subscribe(approved => {
			if (approved) {
				this.deleteIncident();
			}
		});
	}

	deleteIncident() {
		this.store$.dispatch(startDeletingIncident({ pk: this.incident.pk }));
	}

	updateWokOrderMaintenance(payload: Partial<IIncidentPayload>) {
		this.editIncident(payload);
	}

	addChildControl(name: string, control: FormControl) {
		this.incidentForm.addControl(name, control);
	}

	navigateTo(page: CmmsPages) {
		this.setNavigationConfigForHistory();

		this.store$.dispatch(
			SetRightSidebarComponentContext({
				componentContext: {
					currentEntityForEdit: this.incident,
					editEntityType: 'INCIDENTS',
					actionType: 'EDIT',
				},
			})
		);

		this.cmmsSharedService.setExternalDataForNewComponent(page, this.incident);
		this.sidebarNavigation.navigateTo(page, ACTIVE_PAGE_CONFIG[page].sidebarConfig);
	}

	viewSelected(item: { data: any; entityType: CmmsPages }) {
		this.sidebarService.viewCurrentEntity(
			EditIncidentComponent,
			CmmsPages.editIncident,
			item,
			this.incident
		);
	}

	navigateToExist(pageData: { page: CmmsPages; tableType: TableType }) {
		this.setNavigationConfigForHistory();

		this.store$.dispatch(
			SetRightSidebarComponentContext({
				componentContext: {
					tableTypeForExistingEntity: pageData.tableType,
					actionType: 'EDIT',
					currentEntityForEdit: this.incident,
					editEntityType: 'INCIDENTS',
				},
			})
		);

		this.sidebarNavigation.navigateTo(
			CmmsPages.existingEntities,
			sidebarHeaders[pageData.tableType]
		);
	}

	openAssets() {
		this.setNavigationConfigForHistory();

		this.store$.dispatch(
			SetRightSidebarComponentContext({
				componentContext: {
					tableTypeForExistingEntity: TableType.ASSETS,
					currentEntityForEdit: this.incident,
					editEntityType: 'INCIDENTS',
					actionType: 'EDIT',
				},
			})
		);

		this.sidebarNavigation.navigateTo(
			CmmsPages.existingEntities,
			sidebarHeaders[TableType.ASSETS]
		);
	}

	setNavigationConfigForHistory() {
		this.sidebarNavigation.setInitialComponent({
			initialComponent: RightSidebarAliasesEnum.editIncident,
			config: {
				...ACTIVE_PAGE_CONFIG[CmmsPages.editIncident].sidebarConfig,
				title: {
					text: ACTIVE_PAGE_CONFIG[CmmsPages.editIncident].sidebarConfig.title.text,
					endfix: this.incident.incidentId,
				},
			},
			initialPage: CmmsPages.editIncident,
		});
	}

	//TODO This is still a piece of shit in a current implementation of state management, refactor it when possible
	unlinkItem(
		itemType: 'workOrders' | 'requests',
		itemArrayName,
		primaryKey: string
	): void {
		this.incidentService
			.unlinkAttachedElements({
				pk: this.incident.pk,
				[itemType]: primaryKey,
			})
			.subscribe({
				next: () => {
					this[itemArrayName] = this[itemArrayName].filter(
						item => item.pk !== primaryKey
					);
					this.notifySuccess();
					this.cd.markForCheck();
				},
				error: () => this.notifyError(),
			});
	}

	unlinkRequest(request: IRequest) {
		this.unlinkItem('requests', 'attachedRequest', request.pk);
	}

	unlinkWorkOrder(workOrder: IWorkOrder) {
		this.unlinkItem('workOrders', 'attachedWO', workOrder.pk);
	}

	unlinkAsset(asset: ICmmsAsset) {
		const filteredAssets = this.attachedAssets?.length
			? this.attachedAssets.filter(attachedAsset => attachedAsset.pk !== asset.pk)
			: [];

		this.incidentService
			.editIncident({
				pk: this.incident.pk,
				assets: filteredAssets.map(attachedAsset => {
					return { id: attachedAsset.pk, name: attachedAsset.name };
				}),
			})
			.subscribe({
				next: payload => {
					this.attachedAssets = payload.incident.assets || [];
					this.incident = payload.incident;
					this.notifySuccess();
					this.cd.markForCheck();
				},
				error: () => this.notifyError(),
			});
	}

	submitComment(comment: {
		commentText: string;
		sendAsEmail: boolean;
		mentions: string[];
	}) {
		this.commentService
			.addCommentToEntity('incident', this.incident.pk, comment)
			.subscribe({
				next: res => {
					if (!res.success) {
						this.notify.error(this.translateService.instant('error_comment_save'));
					}

					const incidentCopy = AuUtilsFunctions.deepCopyObject(this.incident);
					incidentCopy.comments.unshift(res.comment);

					this.incident = incidentCopy;
					this.cd.markForCheck();
					this.scrollToBottom();
					//we will rewrite the workspace in near future, temp fix.
					setTimeout(() => {
						this.scrollToBottom();
					}, 100);
				},
				error: error => {
					this.notify.error(AuErrorAdapter.getTextFromGqlError(error));
				},
			});
	}

	deleteCommentConfirmation($event: { commentId: string }) {
		const dialog = this.dialogService.openAlertDialog({
			title: this.translateService.instant('dialog_delete_comment_title'),
			description: this.translateService.instant('dialog_delete_comment_description'),
			actionBtnText: this.translateService.instant('delete'),
		});

		this.dialogService.closedByEnter(dialog).subscribe(approved => {
			if (approved) {
				this.deleteComment($event.commentId);
			}
		});
	}

	deleteComment(commentId: string) {
		this.commentService.deleteComment(commentId).subscribe({
			next: res => {
				if (!res.success) {
					this.notify.error(this.translateService.instant('error_comment_delete'));
				}

				const incidentCopy = AuUtilsFunctions.deepCopyObject(this.incident);
				incidentCopy.comments = this.incident.comments.filter(
					comment => comment.id !== commentId
				);

				this.incident = incidentCopy;
				this.cd.markForCheck();
			},
			error: error => {
				this.notify.error(AuErrorAdapter.getTextFromGqlError(error));
			},
		});
	}

	editComment($event: { commentId: string; commentText: string }) {
		this.commentService.editEntityComment(
			$event.commentId,
			$event.commentText,
			this.incident,
			(updatedEntityItem: IIncident) => {
				this.incident = updatedEntityItem;
				this.cd.markForCheck();
			}
		);
	}
	openMessageComponent() {
		this.emailService.setMessageExternalData(
			this.incident,
			`Avvik ${this.incident.incidentId}`,
			this.locationAncestry,
			this.attachedFiles
		);
		this.navigateTo(CmmsPages.messages);
	}

	scrollToBottom() {
		const activeElement = this.el.nativeElement.querySelector('.edit-incident-container');

		if (activeElement) {
			activeElement.scrollIntoView({ behavior: 'smooth', block: 'end' });
		}
	}

	private notifySuccess() {
		this.notify.success(
			`${this.translateService.instant('incident')} ${this.translateService.instant('has_been_updated_successfully')}`
		);
	}

	private notifyError() {
		this.notify.error(
			`${this.translateService.instant('failed_to_update')} ${this.translateService.instant('incident')}`
		);
	}

	ngOnDestroy() {
		this.destroy$.next();
		this.destroy$.complete();
	}

	protected readonly fileTypesConfig = fileTypesConfig;
}
